<template>
  <span class="sticker-status">
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">    
          <div v-bind="attrs" v-on="on">
                <bx-tag v-if="status == 0" color="yellow">{{$t("lang.common.pending")}}</bx-tag>    
                <bx-tag v-if="status == 1" color="green">{{$t("lang.common.completed")}}</bx-tag>

        </div>
      </template>
      <span>{{ statusTooltip }}</span>
    </v-tooltip>
  </span>
</template>
<script>
export default {
  name: "sticker-status",
  props: {
    status: {
      type: [Number, String],
      default: 0
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusTooltip: {
      get() {
        let text;
        if (this.status === 0) {
          text = this.$t("lang.order_status.status_0");
        } else if (this.status === 1) {
          text = this.$t("lang.order_status.status_1");
        } else if (this.status === 2) {
          text = this.$t("lang.order_status.status_2");
        } else if (this.status === 3) {
          text = this.$t("lang.order_status.status_3");
        } else if (this.status === 4) {
          text = this.$t("lang.order_status.status_4");
        }
        return text;
      }
    }
  }
};
</script>
